import React, { useEffect } from "react";
import { Form } from "react-bootstrap";
import { FaQuestion } from "react-icons/fa";
import Footer from "../Layout/Footer";
import Header from "../Layout/Header";
import Slider from "react-slick";
import { useSelector } from "react-redux";
import BaseUrl from "../../BaseUrl";
import axios from "axios";
import { useState } from "react";
import { useHistory } from "react-router-dom";
const postBlog = [
  {
    image: require("./../../images/testimonials/pic1.jpg"),
  },
  {
    image: require("./../../images/testimonials/pic2.jpg"),
  },
  {
    image: require("./../../images/testimonials/pic3.jpg"),
  },
  {
    image: require("./../../images/testimonials/pic2.jpg"),
  },
];
export const Advisor = () => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [law, setLaw] = useState("");
  const [state, setState] = useState("");
  const [website, setWebsite] = useState("");
  const [firmname, setFrimname] = useState("");
  const [fielderr, setFielderr] = useState("");
  const history = useHistory("");
  const token = useSelector((state) => state.auth.auth);
  console.log(token, token.token, "token");
  // CommonJS
  const Swal = require("sweetalert2");
  const Helpme = () => {
    Swal.fire({
      icon: "question",
      title: "TO BE CONSIDRED, YOU MUST HAVE:",
      html: "5+ YEARS PRACTICING LAW <br> <br> PASSION FOR PROVIDING GREAT CLIENTS SERVICES <br> <br>  A SPOTLESS STATE BAR RECORD AND ONLINE REPUTATION <br> THE ABILITY TO EXPLAIN COMPLEX LEGAL ISSUES IN <br> SIMPLE WAYS <br> <br> EXPERIENCE WITH TECHNOLOGY, AND CONFORT WITH  VIRTUAL COLLABORATION ",
      confirmButtonText: "UnderStand",
    });
  };
  useEffect(() => {
    const Helpme = () => {
      const Swal = require("sweetalert2");
      Swal.fire({
        icon: "question",
        title: "TO BE CONSIDRED, YOU MUST HAVE:",
        html: "5+ YEARS PRACTICING LAW <br> <br> PASSION FOR PROVIDING GREAT CLIENTS SERVICES <br> <br>  A SPOTLESS STATE BAR RECORD AND ONLINE REPUTATION <br> THE ABILITY TO EXPLAIN COMPLEX LEGAL ISSUES IN <br> SIMPLE WAYS <br> <br> EXPERIENCE WITH TECHNOLOGY, AND CONFORT WITH  VIRTUAL COLLABORATION ",
        confirmButtonText: "UnderStand",
      });
    };
    setTimeout(() => {
      Helpme();
    }, 1000);
  }, [Swal]);
  const settings = {
    slidesToShow: 1,
    arrows: false,
    infinite: true,
    autoplay: true,
    vertical: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  var bnr2 = require("./../../images/testimonials/Advisor.jpg");

  const Advisor_form = () => {
    const form = new FormData();
    form.append("email", email);
    form.append("firm_name", firmname);
    form.append("law_firm_size", law);
    form.append("name", name);
    form.append("state_licensed", state);
    form.append("website", website);
    form.append("is_type", "Advisor");
    // setLoader(true);
    var config = {
      method: "post",
      url: `${BaseUrl.baseurl}/advisor/form/store`,
      data: form,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token.token}`,
      },
    };

    axios(config)
      .then(function (response) {
        if (response?.data?.status === true) {
          localStorage.setItem(
            "userId",
            response?.data?.professionalpageform?.id
          );
          Swal.fire({
            showCloseButton: true,
            toast: true,
            icon: "success",
            title: response?.data?.message,
            animation: true,
            position: "top-right",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", Swal.stopTimer);
              toast.addEventListener("mouseleave", Swal.resumeTimer);
            },
          });
          history.push("/AdvisorQA");
          window.scrollTo({
            top: 100000 * 100000,
            behavior: "smooth",
          });
        } else {
        }
      })
      .catch(function (error) {
        console.log(error);
        setFielderr(error?.response?.data?.errors);
        Swal.fire({
          showCloseButton: true,
          toast: true,
          icon: "error",
          title: error?.response?.data?.message,
          animation: true,
          position: "top-right",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", Swal.stopTimer);
            toast.addEventListener("mouseleave", Swal.resumeTimer);
          },
        });
      });
  };
  return (
    <>
      <div className="page-wraper">
        <Header />
        <div
          className="page-content"
          style={{
            backgroundImage: "url(" + bnr2 + ")",
            backgroundSize: "100% 100%",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div className="page-content">
            <div className="content-block">
              <div className="section-full p-t50 p-b20">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-8 col-md-12">
                      <div
                        className="job-bx submit-resume"
                        style={{ overflow: "hidden" }}
                      >
                        <div className="job-bx-title clearfix">
                          <h5 className="font-weight-700 pull-left text-uppercase text-white">
                            PLEASE COMPLETE THIS FORM TO COMPLETE YOUR INTEREST
                          </h5>
                          <button
                            title="Help Me"
                            type="button"
                            className="float-right rec text-center"
                            onClick={Helpme}
                          >
                            <FaQuestion />
                          </button>
                        </div>
                        <div className="row">
                          <div className="col-lg-6 col-md-6">
                            <div className="form-group">
                              <label style={{ color: "white" }}>
                                Your Name
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Job Title"
                                onChange={(e) => setName(e.target.value)}
                              />
                              {fielderr?.name
                                ? fielderr?.name.map((e) => (
                                    <h6 className="text-danger mt-2">{e}</h6>
                                  ))
                                : null}
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6">
                            <div className="form-group">
                              <label style={{ color: "white" }}>
                                Firm Name
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="info@gmail.com"
                                onChange={(e) => setFrimname(e.target.value)}
                              />
                              {fielderr?.firm_name
                                ? fielderr?.firm_name.map((e) => (
                                    <h6 className="text-danger mt-2">{e}</h6>
                                  ))
                                : null}
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6">
                            <div className="form-group">
                              <label style={{ color: "white" }}>Email</label>
                              <input
                                type="email"
                                className="form-control"
                                placeholder="info@gmail.com"
                                onChange={(e) => setEmail(e.target.value)}
                              />
                              {fielderr?.email
                                ? fielderr?.email.map((e) => (
                                    <h6 className="text-danger mt-2">{e}</h6>
                                  ))
                                : null}
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6">
                            <div className="form-group">
                              <label style={{ color: "white" }}>WebSite</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="info@gmail.com"
                                onChange={(e) => setWebsite(e.target.value)}
                              />
                              {fielderr?.website
                                ? fielderr?.website.map((e) => (
                                    <h6 className="text-danger mt-2">{e}</h6>
                                  ))
                                : null}
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6">
                            <div className="form-group">
                              <label style={{ color: "white" }}>
                                Law Firm Size
                              </label>
                              <Form.Control
                                as="select"
                                custom
                                className="custom-select"
                                onChange={(e) => setLaw(e.target.value)}
                              >
                                <option selected disabled>
                                  Select Your Firm Size
                                </option>
                                <option>Option 1</option>
                                <option>Option 2</option>
                                <option>Option 3</option>
                              </Form.Control>
                              {fielderr?.law_firm_size
                                ? fielderr?.law_firm_size.map((e) => (
                                    <h6 className="text-danger mt-2">{e}</h6>
                                  ))
                                : null}
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6">
                            <div className="form-group">
                              <label style={{ color: "white" }}>
                                State Licensed
                              </label>
                              <Form.Control
                                as="select"
                                custom
                                className="custom-select"
                                onChange={(e) => setState(e.target.value)}
                              >
                                <option>1 </option>
                                <option>2 </option>
                                <option>3 </option>
                                <option>4 </option>
                                <option>5 </option>
                              </Form.Control>
                              {fielderr?.state_licensed
                                ? fielderr?.state_licensed.map((e) => (
                                    <h6 className="text-danger mt-2">{e}</h6>
                                  ))
                                : null}
                            </div>
                          </div>
                        </div>
                        <button
                          className="site-button m-b30"
                          onClick={Advisor_form}
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-12">
                      <div className="section-full p-tb70 overlay-black-dark text-white text-center bg-img-fix">
                        <div className="container">
                          <div className="text-center text-white">
                            <h5 className="fw4">Few words from candidates</h5>
                          </div>
                          <Slider
                            className="blog-carousel-center owl-carousel owl-none "
                            {...settings}
                          >
                            {postBlog.map((item, index) => (
                              <div className="item p-3" key={index}>
                                <div className="testimonial-5">
                                  <div className="testimonial-text">
                                    <p>
                                      Lorem Ipsum is simply dummy text of the
                                      printing and typesetting industry. Lorem
                                      Ipsum has been the industry.
                                    </p>
                                  </div>
                                  <div className="testimonial-detail clearfix">
                                    <div className="testimonial-pic radius shadow">
                                      <img
                                        src={item.image}
                                        width="100"
                                        height="100"
                                        alt=""
                                      />
                                    </div>
                                    <strong className="testimonial-name">
                                      David Matin
                                    </strong>
                                    <span className="testimonial-position">
                                      Student
                                    </span>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </Slider>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};
